module.exports = __webpack_public_path__ + "b0a5e0724b22f5e5a89e2e31e10f92bf.jpg";